import React, {useEffect} from 'react';
import { useTranslation } from 'react-i18next';
import { LoadingButton } from '@mui/lab';
import { InputProfile, SelectProfile } from '../../../components/profile';

export const WixIntegrationForm = ({
    props,
    createLoading,
    platform,
    project
}) => {
  const { t } = useTranslation();

  return (
    <div className='flex flex-col gap-4'>
        <div className="w-full">
            <InputProfile
                formikProps={props}
                type="text"
                text="Clé API"
                name="api_key"
                placeholder="IST.XXXX"
            />
        </div>

        <div className="w-full">
            <InputProfile
                formikProps={props}
                type="text"
                text="ID du compte"
                name="account_id"
                placeholder="XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXX"
            />
        </div>

        <div className="w-full">
            <InputProfile
                formikProps={props}
                type="text"
                text="ID du site"
                name="site_id"
                placeholder="XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXX"
            />
        </div>
            
        <LoadingButton
            type="submit"
            loading={createLoading || props.isSubmitting}
            variant="contained"
            sx={{
                textTransform: 'none',
                bgcolor: '#8b5cf6',
                '&:hover': {
                    bgcolor: '#7c3aed',
                },
            }}
        >
            {project ? platform?.updateBtnText :  platform?.btnText}
        </LoadingButton>
    </div>
  );
};


export const WixSettingsForm = ({
    props,
    onlineDatas=null,
    isExport=false
}) => {
  const { t } = useTranslation();

  const publish_states = [
    { name: "publish", label: "Publié" },
    { name: "draft", label: "Brouillon" }
  ];
  
  useEffect(() => {
    if (!props.values["blog_url"] && onlineDatas) {
      props.setFieldValue('blog_url', onlineDatas["blog_url"]);
    }
  }, [onlineDatas]);

  return (
    <div>
        <div className="flex flex-col gap-2 mb-4">
            <div className="sm:flex sm:space-x-4">
                
                <div className="sm:w-1/2 flex flex-col gap-4">
                    <div className="w-full">
                        <SelectProfile
                            formikProps={props}
                            options={publish_states}
                            text={t("publish-states", "État de publication")}
                            name="publish_status"
                            required={true}
                        />
                    </div>
                </div>

                <div className="sm:w-1/2 flex flex-col gap-4">
                    <div className="w-full">
                        <SelectProfile
                            formikProps={props}
                            options={onlineDatas ? [{ name: "", label: "Sélectionner un auteur" }, ...onlineDatas?.members] : [{ name: "", label: "Sélectionner un auteur" }]}
                            text="Auteur"
                            name="member_id"
                            required={true}
                        />
                    </div>
                </div>

            </div>

            {!isExport ??
                <div className="w-full">
                    <InputProfile
                        formikProps={props}
                        type="text"
                        text="Chemin d'URL du blog par défaut"
                        name="blog_url"
                        placeholder="Ex: https://botblogr.com/blog"
                    />
                </div>
            }
        </div>
    </div>
  );
};